import axios from "../utils/axios";

export const getAllJobTitles = async (page = 1, per_page = 15, filters = {}) => {
    const params = { ...filters };
    if (page) params.page = page;
    if (per_page) params.per_page = per_page;
    const { data } = await axios.get('/job-titles', { params });
    return data;
};

export const getJobTitlesForSelect = async () => {
    const { data } = await axios.get('/job-titles/for-select');
    return data;
};

export const getJobTitle = async (id) => {
    const { data } = await axios.get(`/job-titles/${id}`);
    return data;
};

export const createJobTitle = async (req) => {
    const { data } = await axios.post('/job-titles', req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const updateJobTitle = async (req, id) => {
    const { data } = await axios.put(`/job-titles/${id}`, req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const deleteJobTitle = async (id) => {
    const { data } = await axios.delete(`/job-titles/${id}`, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const deleteAllJobTitles = async (req) => {
    const { data } = await axios.delete('/job-titles/mass-destroy', {
        data: req,
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const forceDeleteJobTitle = async (id) => {
    const { data } = await axios.delete(`/job-titles/${id}/force-delete`, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const forceDeleteAllJobTitles = async (ids) => {
    const { data } = await axios.delete('/job-titles/mass-force-delete', {
        data: ids,
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const restoreJobTitle = async (id) => {
    const { data } = await axios.post(`/job-titles/${id}/restore`, {}, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const restoreAllJobTitles = async (req) => {
    const { data } = await axios.post('/job-titles/mass-restore', req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};
